import { memo, useCallback } from "react";
import { Radio, Tooltip } from "@narmi/design_system";

import { useLocalization } from "@fluent/react";
import { useCurrentUser } from "../../../../../contexts/CurrentUserContext";

import styles from "./DeliveryMethod.module.scss";

interface DeliveryMethodProps {
  value: API.DeliveryChannel;
  onChange: (channel: API.DeliveryChannel) => void;
}

const DeliveryMethod = memo(({ value, onChange }: DeliveryMethodProps) => {
  const { l10n } = useLocalization();
  const { currentUser } = useCurrentUser();

  const hasEmail = value === "email";
  const hasSMS = value === "sms";
  const isSmsDisabled = !currentUser?.phone?.number;

  const handleCheck = useCallback(
    (channel: string) => {
      if (channel === "sms" && isSmsDisabled) return;
      onChange(channel as API.DeliveryChannel);
    },
    [isSmsDisabled, onChange]
  );

  const smsLabel = l10n.getString(
    "alerts-tooltip-label-sms-disabled",
    {},
    "Update your phone number in profile settings to receive SMS alerts."
  );

  return (
    <div className={styles.container}>
      <Radio
        name="deliveryMethod"
        value="email"
        checked={hasEmail}
        onCheck={handleCheck}
      >
        {l10n.getString("alerts-delivery-channel-email")}
      </Radio>
      {isSmsDisabled ? (
        <Tooltip text={smsLabel}>
          <Radio
            name="deliveryMethod"
            value="sms"
            checked={hasSMS}
            isDisabled
            onCheck={handleCheck}
          >
            {l10n.getString("alerts-delivery-channel-sms")}
          </Radio>
        </Tooltip>
      ) : (
        <Radio
          name="deliveryMethod"
          value="sms"
          checked={hasSMS}
          onCheck={handleCheck}
        >
          {l10n.getString("alerts-delivery-channel-sms")}
        </Radio>
      )}
    </div>
  );
});

export default DeliveryMethod;
